export default "__VITE_ASSET__Dhur_8fe__"